import R from 'ramda'

const LIKE_OR_RETWEET_TRIGGER_TYPE = 'LIKE_OR_RETWEET'
const LIKE_OR_RETWEET_DISPLAY_TYPE = 'Like OR Retweet'
const EXISTING_TWEET_ACTION = 'EXISTING_TWEET'

const isLikeOrRetweetTrigger = R.propEq('type', LIKE_OR_RETWEET_TRIGGER_TYPE)

const convertLikeOrRewtweetWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(LIKE_OR_RETWEET_DISPLAY_TYPE),
  action: R.always(EXISTING_TWEET_ACTION),
  value: R.prop('data')
})

export {
  isLikeOrRetweetTrigger,
  convertLikeOrRewtweetWidgetTriggerToFormTrigger
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/widget-to-form/like_or_retweet.js